import { createAction } from '@reduxjs/toolkit';

export const GET_SEARCH_STRING = 'search/setSearchString';

export const setSearchData = createAction(GET_SEARCH_STRING, text => ({
    payload: text,
}));
